export default __webpack_public_path__ + "static/vehicle-console-1a4f0410f16c6e34eeab781b2e55ae1f.png";